import { AfterViewInit, Component, OnDestroy,Input, Output, EventEmitter} from '@angular/core';
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-my-line',
  template: `
    <div style="width:100%;"  >
      <div echarts [options]="options" class="echart"  style="height:200px;" ></div>
    </div>
  `,
})
export class MyLineComponent implements AfterViewInit, OnDestroy {
  @Output() emitList = new EventEmitter();
  @Input() orgData: lineData;  //已選資料_來源
  // {
  //   x: 標
  //   line:資料
  //   title:小標
  // }

  options: any = {};
  themeSubscription: any;

  constructor(private theme: NbThemeService) {
  }





  ngAfterViewInit() {

    



    this.themeSubscription = this.theme.getJsTheme().subscribe(config => {

      const colors = config.variables;
      const echarts: any = config.variables.echarts;

      this.options =  {
        backgroundColor: echarts.bg,
        color: [colors.warningLight, colors.infoLight, colors.dangerLight, colors.successLight, colors.primaryLight],
        legend: {
          data:   this.orgData.line.map(x=>x.name)
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
           

            let title = ['本期','上期']

            let html = `${params[0].axisValue}<br/>`

            for (const idx in params) {
             let x = params[idx]
             html+= `
              ${x.marker}  ${title[idx]}
              <b>${x.value}</b><br/>
              `

            }
            return html;
          },
        },
        grid: {
         
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {}  //圖片下載功能XD
          // }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.orgData.x,//['11/18', '11/19', '11/20', '11/21', '11/22', '11/23', '11/24']
        },
        yAxis: {
          type: 'value'
        },
        series: this.orgData.line.map(x=>{
          return  {
            id: x.name,
            name: x.name,
            type: 'line',
            data: x.value
          }
        })
        // [
        //   {
        //     name: '本期',
        //     type: 'line',
        //     stack: 'Total',
        //     data: [120, 132, 101, 134, 90, 230, 210]
        //   },
        //   {
        //     name: '上期',
        //     type: 'line',
        //     stack: 'Total',
        //     data: [220, 182, 191, 234, 290, 330, 310]
        //   },       
        // ]
      };
    });
  }

  ngOnDestroy(): void {
    this.themeSubscription.unsubscribe();
  }
}


class lineData  {
  x:string[] = ["e"]
  line:{ 
    name:string ,
    value:number[]
  }[]
}